import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Session } from 'src/app/models/session';
import { AlertController, InfiniteScrollCustomEvent, IonModal, ModalController } from '@ionic/angular';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { SessionFormComponent } from '../form-session/session-form.component';
import { UserService } from 'src/app/services/user.service';
import { DatePipe, formatDate } from '@angular/common';
import { Observable, concat, from, merge, of } from 'rxjs';
import { concatMap, filter, map, startWith, switchMap, tap, toArray } from 'rxjs/operators';
import { Address } from 'src/app/models/address';
import { MyTimer } from 'src/app/models/my-timer';
import { User } from 'src/app/micro-services/user/models/user';

type remaining = {
  days: number;
  hours: number;
  minutes: number;
  secondes: number;
};

@Component({
  selector: 'app-list-session',
  templateUrl: './list-session.component.html',
  styleUrls: ['./list-session.component.scss']
})
export class ListSessionComponent implements OnInit {

  pageNumber: number = 1;

  hours : remaining = { days : 0, hours : 0, minutes : 0 , secondes : 0};

  nestSessionTime : remaining = { days : 0, hours : 0, minutes : 0 , secondes : 0};

  @ViewChild(IonModal) modal: IonModal;

  sessions$: Observable<Session[]> | undefined;
  sessionsHisto$: Observable<Session[]> | undefined;
  coach: User;
  timer: MyTimer;

  constructor(
    public apiProvider: ApiProviderService,
    public userService: UserService,
    private modalCtrl: ModalController,
    private datePipe: DatePipe,
    public alertController: AlertController
  ) {

  }

  ngOnInit() {
    this.coach = this.userService.getUser();
    this.sessions$ = this.getData(1);
    this.sessionsHisto$ = this.getSessionsHisto(1);
    this.startChrono();
  }

  handleRefresh(event){
    this.ngOnInit();
    event.target.complete();
  }

  onIonInfinite(ev) {
    this.pageNumber ++;
    this.getData(this.pageNumber).pipe(
      concatMap( (newSessions) => {
        return this.sessions$.pipe(
          map((items) => {
          return [...items, ...newSessions];
        })
        );
      })
    ).subscribe((items) => {
      this.sessions$ = of(items);
      ev.target.complete();
    });
  }


  onIonInfiniteHisto(ev) {
    this.pageNumber ++;
    this.getSessionsHisto(this.pageNumber).pipe(
      concatMap( (newSessions) => {
        return this.sessionsHisto$.pipe(
          map((items) => {
          return [...items, ...newSessions];
        })
        );
      })
    ).subscribe((items) => {
      this.sessionsHisto$ = of(items);
      ev.target.complete();
    });
  }

  getData(page: number): Observable<Session[]> {
    return this.apiProvider.getNextSessionsByCoach(this.coach, this.datePipe.transform(new Date(), 'yyyy-MM-dd H:mm:ss'), this.pageNumber, 15);
  }

  getSessionsHisto(page: number): Observable<Session[]> {
    return this.apiProvider.getPreviousSessionsByCoach(this.coach, this.datePipe.transform(new Date(), 'yyyy-MM-dd H:mm:ss'), this.pageNumber, 15);
  }

  // SESSION
  async addSession() {

    const modalAddSession = await this.modalCtrl.create({
      component: SessionFormComponent,
      id: "modalAddSession"
    });

    modalAddSession.present();

    const { data, role } = await modalAddSession.onWillDismiss();

    let d : Session = data as Session;
    if (role == 'create') {
      this.addSessionToSessions(d);
    }

  }

  addSessionToSessions(session : Session){
    this.sessions$ = this.sessions$.pipe(
      map((sessions : Session[]) => {
        let newSess : Session[] = [];
        
        if(sessions.length > 0){
          if(new Date(sessions[sessions.length - 1].endDate).getTime() > new Date(session.endDate).getTime()){
            newSess = [...sessions, session];
            newSess.sort((a : Session, b : Session) => new Date(a.endDate).getTime() - new Date(b.endDate).getTime());
          } else {
            newSess = sessions;
          }
        }else{
          newSess = [...sessions, session]
        }
        return newSess
      })
    );
    this.startChrono();
  }

  async deleteSession(session: Session) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Alert',
      subHeader: 'Suppression',
      message: 'Etes vous sûr de vouloir supprimer cette session ?',
      buttons: ['Cancel', 'Delete'],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    if(role != 'cancel' && role != 'backdrop'){
      this.apiProvider.deleteSession(session).subscribe();
      this.removeSession(session.id);
      this.startChrono();
    }

  }

  cancel() {
    this.modal.dismiss(null, 'cancel');
  }

  async editSession(session: Session){
    const modalEdition = await this.modalCtrl.create({
      component: SessionFormComponent,
      componentProps: { session : session }
    });
    modalEdition.present();

    const { data, role } = await modalEdition.onWillDismiss();
    
    if (role === 'edit') {
      let d : Session = data;
      if(this.selectedTab == 0){
        this.removeSession(d.id);
        this.addSessionToSessions(d);
      }
    }
  }

  removeSession(id : number){
    this.sessions$ = this.sessions$.pipe(
      map(sessions => {
        return sessions.filter(session => session.id != id);
      })
    )
  }

  selectedTab = 0;
  selectTab(tabIndex: number) {
    this.selectedTab = tabIndex;
  }

  screenAddress(address: Address, length : number) : string{
    let addr = "";
    if(address){
      addr =  address.streetNumber + " " + address.addresse + ", " + address.city;
    }
    if(addr.length >= length){
      addr = addr.slice(0,length);
      addr += " ..."
    }


    return addr;
  }

  startChrono(){
    this.sessions$.pipe(
      map((session)=> {
        return session[0];
      })
    ).subscribe(
      (session) => {
        if(session){
          this.hours = this.getTimeDifference(new Date(), new Date(session.startDate));
          this.timer = new MyTimer(this.hours.days,this.hours.hours, this.hours.minutes, this.hours.secondes);
          this.timer.startTimer();
        }
      }
    )
  }

  getTimeDifference(startDate: Date, endDate: Date): { days: number, hours: number, minutes: number, secondes: number } {

    const millisecondsPerSecond = 1000;
    const millisecondsPerMinute = millisecondsPerSecond * 60; // Nombre de millisecondes par minute
    const millisecondsPerHour = millisecondsPerMinute * 60; // Nombre de millisecondes par heure
    const millisecondsPerDay = millisecondsPerHour * 24; // Nombre de millisecondes par jour
  
    const startMilliseconds = startDate.getTime(); // Temps en millisecondes de la date de début
    const endMilliseconds = endDate.getTime(); // Temps en millisecondes de la date de fin
  
    const diffMilliseconds = endMilliseconds - startMilliseconds; // Différence de temps en millisecondes
    
    const daysDifference = Math.floor(diffMilliseconds / millisecondsPerDay); // Différence de jours arrondie à l'entier inférieur
    const hoursDifference = Math.floor((diffMilliseconds % millisecondsPerDay) / millisecondsPerHour); // Différence d'heures arrondie à l'entier inférieur
    const minutesDifference = Math.floor((diffMilliseconds % millisecondsPerHour) / millisecondsPerMinute); // Différence de minutes arrondie à l'entier inférieur
    const secondesDifference = Math.floor((diffMilliseconds % millisecondsPerMinute) / millisecondsPerSecond);

    return { days: daysDifference, hours: hoursDifference, minutes: minutesDifference , secondes: secondesDifference};
  }

  
}

